<script setup>
    import { ref, onMounted, watch } from 'vue';
    import axios from 'axios';
    import * as bootstrap from 'bootstrap';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    const props = defineProps(['fetchUrl','nutzergruppen', 'endDate']);


    const teilnehmer = ref({
        Rechnungsempfaenger: '',
        Teilnehmer: '',
        Vorname: '',
        Name: '',
        Firmennachzahler: '',
        Kartennummer: '',
        Bemerkung: '',
        Vertragsbeginn: setStartDate(),
        //Vertragende auf 2025.12.31,da die Veträge bis dahit gültig sind
        Vertragsende: `${props.endDate}T00:00:00.000Z`,
        Tarifnummer: '',
        Tarifbezeichnung: '',
        Stammanlagennummer: '',
        Stammanlagenbezeichnung: '',
        Wochenprogrammgueltigkeit: '',
        Wochenprogrammnummer: '',
        Monatspauschale: '',
        Nachzahltarif: '',
        Ueberziehungsgebuehr: '',
        RabattTeilnehmer: '0',
        Gutschrift: '',
        Bestpreismin: '',
        Bestpreismax: '',
        Status: '',
        Abrechnungsart: 'Normal',
        Nutzergruppe: ''
    });


    const minDate = ref(null);
    const maxDate = ref(null);

    const submitResult = ref(null);
    const submitError = ref(null);
    const isFirmennachzahler = ref(false);
    const isLoading = ref(null);
    const showInfo = ref(null);

    const show_nutzergruppe = ref(false);
    const nutzergruppenArray = ref([]);
    onMounted(() => {

        nutzergruppenArray.value = JSON.parse(props.nutzergruppen);

    });

    const getShowNutzerGruppe = (tarifnummer) => {
        axios.get('/nutzergruppen/' + tarifnummer )
            .then(response => {
                if(response.data){
                    show_nutzergruppe.value = true;
                    teilnehmer.value.Nutzergruppe = "1001";
                } else{
                    show_nutzergruppe.value = false;
                    teilnehmer.value.Nutzergruppe = "";
                }
            })
            .catch(error => {
                 console.error(error);

            });
    };


    watch(() => teilnehmer.value.Tarifnummer, (newVal) => {
        // check if the tarif to nutzergruppe relation exists. If not show the selection box for the user
        if (newVal.length > 0) {
            getShowNutzerGruppe(newVal);
        }
    });


    // Loads a bootstrap modal & saving the new teilnehmer.
    async function saveTeilnehmer() {
        try {
        isLoading.value = true;
        showInfo.value = true;
        const response = await axios.post(props.fetchUrl, teilnehmer.value);
        submitResult.value = response;

        // Close the first modal after a one-second delay
        setTimeout(() => {
            const currentModal = document.querySelector('#createTeilnehmer');
            const modal = bootstrap.Modal.getInstance(currentModal);
            modal.hide();

            // If the checkbox is checked, open the additional modal after a one-second delay
            if (isFirmennachzahler.value) {
                setTimeout(() => {
                    isLoading.value = null;
                    submitResult.value = null;
                    showInfo.value = null;


                    const rechnungsempfaengerValue = teilnehmer.value.Rechnungsempfaenger;
                    const teilnehmerValue = teilnehmer.value.Teilnehmer;
                    // Set Rechnungsempfaenger and Teilnehmer values in the new modal
                    const additionalModal = document.querySelector('#createNachzahler');
                    additionalModal.querySelector('#rechnungsempfaenger').value = rechnungsempfaengerValue;
                    additionalModal.querySelector('#teilnehmer').value = teilnehmerValue;
                    // Show the new modal for Firmennachzahler
                    const additionalModalInstance = new bootstrap.Modal(additionalModal);
                    additionalModalInstance.show();
                    teilnehmer.value.Teilnehmer = teilnehmer.value.Teilnehmer+1;
                }, 1000);
            } else {
                // If the checkbox is not checked, reload the page after a two-second delay

                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        }, 1000);

        } catch (error) {
            isLoading.value = false;
            showInfo.value = false;
            submitError.value = error;

            setTimeout(() => {
                submitError.value = null;
            }, 3000);
        }
    }

    function formatDateJS( date){
        if( typeof(date) != "string" || date.length != 8 ){
            return setStartDate()
        }
        return date.substring(0,4) + "-" + date.substring(4,6) + "-" + date.substring(6) + "T00:00:00.000Z";
    }

    function setStartDate(){
        const now = new Date();
        const day = now.getDate() < 10 ? "0"+now.getDate() : now.getDate();
        const month = now.getMonth()+1 < 10 ? "0"+(now.getMonth()+1) : now.getMonth()+1;
        const startDate = now.getFullYear() + '-' + month + '-' + day + "T00:00:00.000Z";
        return startDate;
    }

    // Check if Rechnungsempfaenger field is beeing manipulated. If yes call function checkRechnungsempfaenger.
    watch(() => teilnehmer.value.Rechnungsempfaenger, (newValue) => {
            if (newValue.trim() !== '') {
                checkRechnungsempfaenger(newValue);
                checkRechnungsempfaengerName(newValue);
            }
        });

        async function checkRechnungsempfaengerName(rechnungsempfaenger) {
            try {
                const response3 = await axios.get(`/teilnehmer/${rechnungsempfaenger}`);
                if (response3.data) {
                    const response3 = await axios.get(`/teilnehmerAddDetail/${rechnungsempfaenger}`);
                    teilnehmer.value.Name = response3.data.Name;
                    teilnehmer.value.Vorname = response3.data.Vorname;

                    if(teilnehmer.value.Vertragsbeginn < formatDateJS( response3.data.Vertragsbeginn) ){
                        teilnehmer.value.Vertragsbeginn = formatDateJS( response3.data.Vertragsbeginn);
                    }
                    if(teilnehmer.value.Vertragsende > formatDateJS( response3.data.Vertragsende)  ){
                        teilnehmer.value.Vertragsende =  formatDateJS(response3.data.Vertragsende);
                    }

                    if( teilnehmer.value.Vertragsbeginn >= teilnehmer.value.Vertragsende ){
                        teilnehmer.value.Vertragsbeginn = formatDateJS( response3.data.Vertragsbeginn);
                        teilnehmer.value.Vertragsende =  formatDateJS(response3.data.Vertragsende);
                    }


                    minDate.value = formatDateJS( response3.data.Vertragsbeginn);
                    maxDate.value = formatDateJS( response3.data.Vertragsende);


                }
            } catch {
                console.log('Rechnungsempfaenger doesnt exist.');
            }
        }

    // Function to check if Rechnungsempfaenger exists. If exists Teilnehmer count +1 is beeing added in teilnehmer.Teilnehmer field.
    // This is the next available Teilnehmer.
    async function checkRechnungsempfaenger(rechnungsempfaenger) {
        try {
            const response = await axios.get(`/teilnehmer/${rechnungsempfaenger}`);
            if (response.data) {
                const countTeilnehmer = await axios.get(`/rechnungsempfaenger/${rechnungsempfaenger}/teilnehmer/count`);
                if (typeof countTeilnehmer.data === 'number') {
                const count = countTeilnehmer.data + 1;
                teilnehmer.value.Teilnehmer = count;
                    } else {
                        console.log('Invalid count data received');
                    }
            }
            else {
                teilnehmer.value.Teilnehmer = 1;
            }
        } catch {
            console.log('Rechnungsempfaenger doesnt exist.');
        }
    }

    // Fetch ParkObjectsTarif from /parkobjectstarif
    async function fetchParkObjectsTarif() {
        try {
            const response = await axios.get('/parkobjectstarif');
            const parktarifModal = document.querySelector('#parktarifModal');
            const groupList = parktarifModal.querySelector('#groupList');

            // Clear existing content
            groupList.innerHTML = '';

            response.data.sort((a, b) => a.group.localeCompare(b.group));

            // Modalgroup names
            response.data.forEach(group => {
                const li = document.createElement('li');
                li.classList.add('list-group-item');
                li.classList.add('fs-3');
                li.classList.add('custom-hover-hand');
                li.textContent = group.group;
                li.addEventListener('click', () => {
                    // When a group is clicked, display its objects
                    displayGroups(group.objects);
                });
                groupList.appendChild(li);
            });

            // Show modal
            const parktarifModalInstance = new bootstrap.Modal(parktarifModal);
            parktarifModalInstance.show();
        } catch {
            console.log('Could not fetch ParkObjectTarifs.');
        }

        // Display Objects and for each Object the Tarif and the Name of the Tarif
        function displayGroups(objects) {
            objects.sort((a, b) => a.tarif - b.tarif);

            const parktarifModal = document.querySelector('#parktarifModal');
            const groupList = parktarifModal.querySelector('#groupList');
            groupList.innerHTML = '';

            objects.forEach(object => {
                const li = document.createElement('li');
                li.classList.add('list-group-item');
                li.classList.add('fs-4');
                li.classList.add('custom-hover-hand');
                li.textContent = `Tarif: ${object.tarif},  Name: ${object.name}`;
                li.addEventListener('click', () => {
                    // When an object is clicked, set its Tarif in input field
                    setTarifValue(object.tarif);
                    // Hide modal
                    const tarifs = bootstrap.Modal.getInstance(parktarifModal);
                    tarifs.hide();
                });
                groupList.appendChild(li);
            });
         }

        // Set teilnehmer.value.Tarifnummer to the selected Tarif
        function setTarifValue(tarif) {
            // Set the selected object's Tarif in the Tarifnummer input field
            teilnehmer.value.Tarifnummer = tarif;
        }
    }

    async function updateRabattTeilnehmer() {
                switch (teilnehmer.value.Abrechnungsart) {
                    case 'Normal':
                        teilnehmer.value.RabattTeilnehmer = '0';
                        break;
                    case 'Bestabrechung':
                        teilnehmer.value.RabattTeilnehmer = '1';
                        break;
                    case 'Vielparker':
                        teilnehmer.value.RabattTeilnehmer = '2';
                        break;
                }
            }

    watch(() => teilnehmer.value.Abrechnungsart, () => {
        updateRabattTeilnehmer();
    });


</script>

<template>
    <form @submit.prevent="submit">
        <div class="row">
            <div class="col-sm-4 mb-2">
                <label for="rechnungsempfaenger">Rechnungsempfaenger (*)</label>
                <input id="rechnungsempfaenger_"
                    type="text"
                    v-model="teilnehmer.Rechnungsempfaenger"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Rechnungsempfaenger !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Rechnungsempfaenger !== 'undefined')" v-html="submitError.response.data.Rechnungsempfaenger[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="tarifnummer">Tarifnummer (*)</label>
                <button class="btn btn-outline-secondary p-0" type="button" @click="fetchParkObjectsTarif"><i class="fas fa-search ps-3"></i></button>
                <input id="tarifnummer"
                    type="text"
                    v-model="teilnehmer.Tarifnummer"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined')" v-html="submitError.response.data.Tarifnummer[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="teilnehmer">Teilnehmer (*)</label>
                <input id="teilnehmer_"
                    type="text"
                    v-model="teilnehmer.Teilnehmer"
                    :readonly="true"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Teilnehmer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Teilnehmer !== 'undefined')" v-html="submitError.response.data.Teilnehmer[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="kartennummer">Kartennummer (*)</label>
                <input id="kartennummer"
                    type="text"
                    v-model="teilnehmer.Kartennummer"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined')" v-html="submitError.response.data.Kartennummer[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="vorname">Vorname (*)</label>
                <input id="vorname"
                    type="text"
                    v-model="teilnehmer.Vorname"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Vorname !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vorname !== 'undefined')" v-html="submitError.response.data.Vorname[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="name">Name (*)</label>
                <input id="name"
                    type="text"
                    v-model="teilnehmer.Name"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Name !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name !== 'undefined')" v-html="submitError.response.data.Name[0]"></div>
            </div>

            <div id="vertragsbeginn" class="col-sm-4">
                <p class="mb-1">Vertragsbeginn (*)</p>
                <div>
                    <VueDatePicker
                        v-model="teilnehmer.Vertragsbeginn"
                        text-input
                        format="yyyy.MM.dd"
                        locale="de"
                        :enable-time-picker="false"
                        selectText="Auswählen"
                        cancelText="Abbrechen"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :class="{
                        'form-control': true,
                        'is-valid': submitResult !== null,
                        'is-invalid': submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined'
                        }"
                        utc
                    />
                    <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined')" v-html="submitError.response.data.Vertragsbeginn[0]"></div>
                </div>
            </div>

            <div id="vertragsende" class="col-sm-4 mb-2">
                <p class="mb-1">Vertragsende (*)</p>
                <div>
                    <VueDatePicker
                        v-model="teilnehmer.Vertragsende"
                        text-input
                        format="yyyy.MM.dd"
                        locale="de"
                        :enable-time-picker="false"
                        selectText="Auswählen"
                        cancelText="Abbrechen"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :class="{
                        'form-control': true,
                        'is-valid': submitResult !== null,
                        'is-invalid': submitError !== null && typeof submitError.response.data.Vertragsende !== 'undefined'
                        }"
                        utc
                    />
                    <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vertragsende !== 'undefined')" v-html="submitError.response.data.Vertragsende[0]"></div>
                </div>
            </div>

            <div class="col-sm-4 mt-4">
                <label><input type="checkbox" v-model="isFirmennachzahler">Kundennachzahler</label>
            </div>

            <div class="col-sm-4">
                <label for="bemerkung">Bemerkung</label>
                <input id="bemerkung"
                    type="text"
                    v-model="teilnehmer.Bemerkung"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Bemerkung !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bemerkung !== 'undefined')" v-html="submitError.response.data.Bemerkung[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="tarifbezeichnung">Tarifbezeichnung</label>
                <input id="tarifbezeichnung"
                    type="text"
                    v-model="teilnehmer.Tarifbezeichnung"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Tarifbezeichnung !== 'undefined'),
                    }"
                    readonly
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Tarifbezeichnung !== 'undefined')" v-html="submitError.response.data.Tarifbezeichnung[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="stammanlagennummer">Stammanlagennummer</label>
                <input id="stammanlagennummer"
                    type="text"
                    v-model="teilnehmer.Stammanlagennummer"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Stammanlagennummer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Stammanlagennummer !== 'undefined')" v-html="submitError.response.data.Stammanlagennummer[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="stammanlagenbezeichnung">Stammanlagenbezeichnung</label>
                <input id="stammanlagenbezeichnung"
                    type="text"
                    v-model="teilnehmer.Stammanlagenbezeichnung"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Stammanlagenbezeichnung !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Stammanlagenbezeichnung !== 'undefined')" v-html="submitError.response.data.Stammanlagenbezeichnung[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="wochenprogrammgueltigkeit">Wochenprogrammgueltigkeit</label>
                <input id="wochenprogrammgueltigkeit"
                    type="text"
                    v-model="teilnehmer.Wochenprogrammgueltigkeit"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Wochenprogrammgueltigkeit !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Wochenprogrammgueltigkeit !== 'undefined')" v-html="submitError.response.data.Wochenprogrammgueltigkeit[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="wochenprogrammnummer">Wochenprogrammnummer</label>
                <input id="wochenprogrammnummer"
                    type="text"
                    v-model="teilnehmer.Wochenprogrammnummer"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Wochenprogrammnummer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Wochenprogrammnummer !== 'undefined')" v-html="submitError.response.data.Wochenprogrammnummer[0]"></div>
            </div>


            <div class="col-sm-4">
                <label for="monatspauschale">Monatspauschale</label>
                <input id="monatspauschale"
                    type="text"
                    v-model="teilnehmer.Monatspauschale"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Monatspauschale !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Monatspauschale !== 'undefined')" v-html="submitError.response.data.Monatspauschale[0]"></div>
            </div>


            <div class="col-sm-4">
                <label for="nachzahltarif">Nachzahltarif</label>
                <input id="nachzahltarif"
                    type="text"
                    v-model="teilnehmer.Nachzahltarif"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Nachzahltarif !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Nachzahltarif !== 'undefined')" v-html="submitError.response.data.Nachzahltarif[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="ueberziehungsgebuehr">Ueberziehungsgebuehr</label>
                <input id="ueberziehungsgebuehr"
                    type="text"
                    v-model="teilnehmer.Ueberziehungsgebuehr"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Ueberziehungsgebuehr !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Ueberziehungsgebuehr !== 'undefined')" v-html="submitError.response.data.Ueberziehungsgebuehr[0]"></div>
            </div>

            <div class="col-sm-4 mb-2">
                <label for="rabattTeilnehmer">RabattTeilnehmer</label>
                <input id="rabattTeilnehmer"
                    type="text"
                    v-model="teilnehmer.RabattTeilnehmer"
                    :readonly="true"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.RabattTeilnehmer !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.RabattTeilnehmer !== 'undefined')" v-html="submitError.response.data.RabattTeilnehmer[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="status">Status</label>
                <input id="status"
                    type="text"
                    v-model="teilnehmer.Status"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Status !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Status !== 'undefined')" v-html="submitError.response.data.Status[0]"></div>
            </div>

            <div class="col-sm-4">
                <label for="abrechnungsart">Abrechnungsart</label>
                <select id="abrechnungsart" v-model="teilnehmer.Abrechnungsart" class="form-select form-control">
                    <option value="Normal">Normal</option>
                    <option value="Bestabrechung">Bestabrechung</option>
                    <option value="Vielparker">Vielparker</option>
                </select>
            </div>

            <div v-if="teilnehmer.Abrechnungsart === 'Bestabrechung'" class="col-sm-4 mb-2">
                <label for="bestpreismin">Minimalbetrag</label>
                <input id="bestpreismin"
                    type="text"
                    v-model="teilnehmer.Bestpreismin"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Bestpreismin !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bestpreismin !== 'undefined')" v-html="submitError.response.data.Bestpreismin[0]"></div>
            </div>
            <div v-if="teilnehmer.Abrechnungsart === 'Bestabrechung'" class="col-sm-4">
                <label for="bestpreismax">Maximalbetrag</label>
                <input id="bestpreismax"
                    type="text"
                    v-model="teilnehmer.Bestpreismax"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Bestpreismax !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bestpreismax !== 'undefined')" v-html="submitError.response.data.Bestpreismax[0]"></div>
            </div>

            <div v-if="teilnehmer.Abrechnungsart === 'Vielparker'" class="col-sm-4 mb-2">
                <label for="gutschrift">Gutschrift</label>
                <input id="gutschrift"
                    type="text"
                    v-model="teilnehmer.Gutschrift"
                    :class="{
                        'form-control': true,
                        'is-valid': (submitResult !== null),
                        'is-invalid': (submitError !== null && typeof submitError.response.data.Gutschrift !== 'undefined'),
                    }"
                />
                <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Gutschrift !== 'undefined')" v-html="submitError.response.data.Gutschrift[0]"></div>
            </div>
            <div class="col-sm-4" v-if="show_nutzergruppe" >
                <label for="status" style="padding: 0%;">Nutzergruppe</label>
                <select value="1001" v-model="teilnehmer.Nutzergruppe" class="form-select" name="nutzergruppe" id="Nutzergruppe">
                    <option v-for="nutzergruppe in nutzergruppenArray" :key="nutzergruppe.nutzergruppe" :value="nutzergruppe.nutzergruppe">
                        {{ nutzergruppe.name }}
                    </option>
                </select>
            </div>

        </div>
        <p>Felder mit einem * sind Pflichtfelder.</p>
        <button type="submit" class="btn btn-primary" @click.prevent="saveTeilnehmer()">Teilnehmer hinzufügen
            <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : '']" :disabled="isLoading"></i>
        </button>
        <p v-if="showInfo" class="text-warning">If saving takes too long, check S&B api connection. Await 60s.</p>
    </form>
    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span>Teilnehmer erfolgreich hinzugefügt.</span>
    </div>
    <div class="alert alert-error" role="alert" v-if="submitError != null">
        <span>{{submitError.response.data.message}}</span>
    </div>
</template>
